import { useState } from "react";
import { toast } from "sonner";
import { useNavigate, useLocation } from "react-router-dom";
import { Linkedin, Twitter, Instagram, ArrowRight } from "lucide-react";
import { NAV } from "../../data/content";
import { api } from "../../lib/api";
import { useI18n } from "../../context/LanguageContext";
import { Wordmark } from "./Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const { t } = useI18n();
  const nav = useNavigate();
  const loc = useLocation();

  const go = (href) => {
    if (loc.pathname !== "/") { nav("/"); setTimeout(() => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" }), 300); }
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  const key = (href) => href.replace("#", "");

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/newsletter", { email }); toast.success("Subscribed! Watch your inbox for lane insights."); setEmail(""); }
    catch { toast.error("Could not subscribe. Try again."); }
  };

  return (
    <footer data-testid="footer" className="relative pt-24 pb-28 md:pb-10 px-6 md:px-10 border-t border-border bg-card/30 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Wordmark sizeClass="h-8" />
            <p className="mt-4 text-muted-foreground max-w-sm">{t("footer.tagline")}</p>
            <form onSubmit={subscribe} data-testid="newsletter-form" className="mt-6 flex max-w-sm rounded-full border border-border overflow-hidden bg-background/50">
              <input data-testid="newsletter-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("footer.newsletter")} className="flex-1 bg-transparent px-5 py-3 text-sm outline-none" />
              <button data-testid="newsletter-submit" className="px-5 bg-primary text-primary-foreground"><ArrowRight className="w-4 h-4" /></button>
            </form>
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-mono-x text-xs tracking-[0.3em] text-muted-foreground mb-5">{t("footer.navigate")}</h4>
            <ul className="space-y-3">
              {NAV.map((n) => <li key={n.href}><button data-testid={`footer-link-${key(n.href)}`} onClick={() => go(n.href)} className="text-muted-foreground hover:text-primary transition-colors">{t(`nav.${key(n.href)}`)}</button></li>)}
              <li><button data-testid="footer-link-insights" onClick={() => nav("/blog")} className="text-muted-foreground hover:text-primary transition-colors">{t("nav.insights")}</button></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-mono-x text-xs tracking-[0.3em] text-muted-foreground mb-5">{t("footer.connect")}</h4>
            <div className="flex gap-3">
              {[Linkedin, Twitter, Instagram].map((I, i) => (
                <a key={i} href="#" data-testid={`social-${i}`} className="w-11 h-11 rounded-full border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors"><I className="w-4 h-4" /></a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 select-none pointer-events-none">
          <h2 className="font-heading font-extrabold tracking-tighter leading-none text-[18vw] text-foreground/[0.04] text-center">CONEXA</h2>
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground border-t border-border pt-6">
          <span>© {new Date().getFullYear()} Conexa Relay Logistics. All rights reserved.</span>
          <span className="font-mono-x text-xs tracking-widest">MOVING THE WORLD, MILE BY MILE</span>
        </div>
      </div>
    </footer>
  );
}
